

import { FC, PropsWithChildren } from 'react';

import { IconButton } from '@eneco/sparky';
import { CloseIcon } from '@eneco/sparky/icons';

interface Props {
  label?: string;
  onClick?: () => void;
}

export const NavigationCloseButton: FC<PropsWithChildren<Props>> = ({ label, onClick }) => (
  <IconButton label={label || 'close'} onClick={onClick}>
    <CloseIcon color="iconSecondary" />
  </IconButton>
);
